export default "__VITE_ASSET__CkjfMsBe__"